import styles from './ResetPasswordRequestReceived.module.scss';
import { useTranslation } from '../../../../i18n/useTranslation';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Link } from 'react-router-dom';

export default function ResetPasswordRequestReceived() {
    const { t } = useTranslation('translation');

    return (
        <div className={styles.content}>
            <CheckCircleIcon className={styles.icon} sx={{ fontSize: '2rem' }} />
            <h1 className={styles.title}>{t('resetPasswordForm.requestReceivedTitle')}</h1>
            <p className={styles.message}>{t('resetPasswordForm.requestReceivedMessage')}</p>
            <Link to="/login" className={styles.login_link}>
                {t('resetPasswordForm.goBackToLoginPage')}
            </Link>
        </div>
    );
}
